const FileStatusClass = {
    Info: "info",
    Warning: "warning",
    Error: "error",
}

class FileStatus {
    status;
    constructor(status) {
        this.status = status
    }

    message(){
        return "";
    }

    isCritical() {
        return this.status === FileStatusClass.Error;
    }

    stylizedMessage() {
        switch (this.status) {
            case FileStatusClass.Info:
                return `<span class="bg-green-300">${this.message()}`;
            case FileStatusClass.Warning:
                return `<span class="bg-yellow-300">${this.message()}</span>`;
            case FileStatusClass.Error:
                return `<span class="bg-red-300">${this.message()}</span>`;
        }
    }
}

export class ScaleProblemStatus extends FileStatus {
    constructor(meshes) {
        super(FileStatusClass.Warning);
        this.meshes = meshes
        this.critical = false;
    }

    message() {
        return "Scale != 1: " + this.meshes.map((v) => v.name).join(", ");
    }
}

export class TextureMapProblemStatus extends FileStatus {
    constructor(images) {
        super(FileStatusClass.Warning);
        this.images = images;
    }

    message() {
        return "FileStatus with inner images: " + JSON.stringify(this.images)
    }
}

export class DuplicateProblemStatus extends FileStatus {
    constructor(file) {
        super(FileStatusClass.Error);
        this.file = file;
    }
    message() {
        return "Duplicate file, path: " + this.file;
    }
}

export class TagsChangedStatus extends FileStatus {
    constructor(oldTags, newTags) {
        super(FileStatusClass.Info);
        this.oldTags = oldTags;
        this.newTags = newTags;
    }

    message() {
        return "Tags changed: " + JSON.stringify(this.oldTags) + " -> " + JSON.stringify(this.newTags);
    }
}

export class DataChangedStatus extends FileStatus {
    constructor() {
        super(FileStatusClass.Info);
    }

    message() {
        return "Binary data changed";
    }
}

export class ServerMetadataEmptyStatus extends FileStatus {
    constructor() {
        super(FileStatusClass.Info);
    }

    message() {
        return "No metadata on the server for that file, should upload";
    }
}

export class AnimationsMissingStatus extends FileStatus {
    constructor() {
        super(FileStatusClass.Info);
    }

    message() {
        return "Metadata doesnt contain info about animation clips";
    }
}

export class UploadStatus extends FileStatus {
    constructor(isUploaded, message) {
        super(isUploaded ? FileStatusClass.Info : FileStatusClass.Error);
        this.text = message;
    }

    message() {
        return this.text;
    }
}

export class MissingLodIndexesProblemStatus extends FileStatus {
    indexes = [];
    constructor(ar) {
        super(FileStatusClass.Error);
        this.indexes = ar;
    }

    message() {
        return "Some LOD levels aren't found: " + this.indexes.join(", ");
    }
}

export class NotLodMeshesFoundProblemStatus extends FileStatus {
    indexes = [];
    constructor(ar) {
        super(FileStatusClass.Error);
        this.indexes = ar;
    }

    message() {
        return "Non-LODs in root: " + this.indexes.join(", ");
    }
}